function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.12,
  width: 64,
  height: 64,
  rx: 32,
  fill: "#22DB69"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 15.698a16.302 16.302 0 100 32.604v-8.553a7.75 7.75 0 010-15.498v-8.553z",
  fill: "#23BF5F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.6,
  d: "M32 48.302a16.302 16.302 0 000-32.604v32.604z",
  fill: "#22DB69"
});

function SvgLanguages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuMTIiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjMyIiBmaWxsPSIjMjJEQjY5Ii8+CjxwYXRoIGQ9Ik0zMiAxNS42OThDMjcuNjc2NSAxNS42OTggMjMuNTMgMTcuNDE1NSAyMC40NzI4IDIwLjQ3MjdDMTcuNDE1NiAyMy41Mjk5IDE1LjY5ODEgMjcuNjc2MyAxNS42OTgxIDMxLjk5OTlDMTUuNjk4MSAzNi4zMjM0IDE3LjQxNTYgNDAuNDY5OCAyMC40NzI4IDQzLjUyN0MyMy41MyA0Ni41ODQyIDI3LjY3NjUgNDguMzAxOCAzMiA0OC4zMDE4TDMyIDM5Ljc0OTFDMjkuOTQ0OCAzOS43NDkxIDI3Ljk3MzggMzguOTMyNiAyNi41MjA1IDM3LjQ3OTRDMjUuMDY3MyAzNi4wMjYxIDI0LjI1MDggMzQuMDU1MSAyNC4yNTA4IDMxLjk5OTlDMjQuMjUwOCAyOS45NDQ3IDI1LjA2NzMgMjcuOTczNiAyNi41MjA1IDI2LjUyMDRDMjcuOTczOCAyNS4wNjcxIDI5Ljk0NDggMjQuMjUwNyAzMiAyNC4yNTA3TDMyIDE1LjY5OFoiIGZpbGw9IiMyM0JGNUYiLz4KPHBhdGggb3BhY2l0eT0iMC42IiBkPSJNMzIgNDguMzAxOEMzNi4zMjM1IDQ4LjMwMTggNDAuNDcgNDYuNTg0MiA0My41MjcyIDQzLjUyN0M0Ni41ODQ0IDQwLjQ2OTkgNDguMzAxOSAzNi4zMjM0IDQ4LjMwMTkgMzEuOTk5OUM0OC4zMDE5IDI3LjY3NjMgNDYuNTg0NCAyMy41Mjk5IDQzLjUyNzIgMjAuNDcyN0M0MC40NyAxNy40MTU1IDM2LjMyMzUgMTUuNjk4IDMyIDE1LjY5OEwzMiAzMS45OTk5TDMyIDQ4LjMwMThaIiBmaWxsPSIjMjJEQjY5Ii8+Cjwvc3ZnPgo=";
export { SvgLanguages as ReactComponent };